// Keep only operation identifiers, never card credentials. Survives closing a
// dialog within this login session, but not logout or a browser reload.
const operations = new Map<string, string>()
let generation = 0

export const cardBlockScope = (userUid: string) => ({ userUid, generation })
type Scope = ReturnType<typeof cardBlockScope>
const key = (scope: Scope, cardUid: string) => JSON.stringify([scope.userUid, cardUid])

export const rememberCardBlock = (scope: Scope, cardUid: string, operationUid: string) => {
	if (scope.generation !== generation) return
	operations.set(key(scope, cardUid), operationUid)
}

export const getRememberedCardBlock = (scope: Scope, cardUid: string) =>
	scope.generation === generation ? operations.get(key(scope, cardUid)) : undefined

export const forgetCardBlock = (scope: Scope, cardUid: string, operationUid: string) => {
	if (getRememberedCardBlock(scope, cardUid) === operationUid) operations.delete(key(scope, cardUid))
}

export const clearCardBlockSessions = () => { operations.clear(); generation += 1 }
